module.exports = __webpack_public_path__ + "static/CooperHewitt-Light-c673f1bd7106775b5ebee40d17c71750.otf";